module.exports = (__webpack_require__(23610))(1932);